import { render, staticRenderFns } from "./TwentySixTable.vue?vue&type=template&id=c2e944ec&"
import script from "./TwentySixTable.vue?vue&type=script&lang=js&"
export * from "./TwentySixTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports